<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3 v-if="createTemplate">Create Docs Template</h3>
              <h3 v-if="assignVariables">Assign Field To Variables</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>

          <template v-if="createTemplate">


            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Name:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="name" v-model="docs_template.name" v-validate="'required'"
                  data-vv-as="Name" />
              </div>
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('name')">{{ errors.first("name") }}</span>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/5 w-full">
                <span>Description:</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-input class="w-full" name="description" v-model="docs_template.description"
                  data-vv-as="Fields Description" />
              </div>

            </div>

            <div class="m-5  warning">
  <p><strong>Note : </strong> The text inside single curly braces { } will be recognized as variable. </p>
</div>


<div id="text_editor">
  <vue-trumbowyg v-model="docs_template.template_text" 
  :config="configs.basic"></vue-trumbowyg>
</div>

<!-- <vue2-tinymce-editor :options="tinmymce_options" v-model="docs_template.template_text"></vue2-tinymce-editor> -->



            <div class="text-center">
              <vs-button class="mt-20 mr-20" @click.prevent="submitForm">Submit</vs-button>

            </div>
            <DataGrid :context="'DocsTemplate'" ref="DocsTemplate" :columnDefs="columnDefs" :rowData="records"
              :dataSource="dataSource">
            </DataGrid>

          </template>

          <template v-if="assignVariables">




<div class="vx-row mb-6">

  <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <h6>Search</h6>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <CampaignAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchCampaign"
      :searchOn="'campaign'" @event-name="handleChildEvent"></CampaignAutocomplete>
            </vs-col>

            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
            </vs-col>

            <div class="ml-5 warning">
  <p><strong>Note : </strong> Please select campaign to assign fields to a variables. </p>
  <p> Choosing multiple fields will be created as table on the docs.</p>
</div>
          </vs-row>

          

          



</div>

<template>



  <vs-row vs-w="12" class="mb-5" v-for="v, index in savedVariables">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
              <h6>{{ v.variable }}</h6>
            </vs-col>
            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <v-select multiple :closeOnSelect="false" :options="acc_con_columns" :key="index" label="name"
        v-model="variable_fields[index]" />
            </vs-col>
          </vs-row>

          <vs-row vs-w="12" class="mb-5" >
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-button @click.prevent="updateVariable">Update Variable</vs-button>

            </vs-col>
          </vs-row>

          
          <div>

</div>


</template>



</template>







        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>

// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
// import { Vue2TinymceEditor } from "vue2-tinymce-editor";

import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'





export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
        configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['superscript', 'subscript'],
                    ['table', 'tableCellBackgroundColor', 'tableBorderColor'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['viewHTML'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
      tinmymce_options:{deprecation_warnings:false},
      editorData: '<p>Content of the editor.</p>',
      acc_con_columns: [],
      selected_campaign: [],
      companySearchComponentKey: 0,
      account_columns: [],
      contact_columns: [],
      csv_table_columns: [],
      editor: null,
      variable_fields: [],
      savedVariables: [],
      createTemplate: true,
      assignVariables: false,
      columnDefs: [
        {
          headerName: "Name",
          field: "name",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          },
        },
        {
          headerName: "Description",
          field: "description",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        },
        {
          headerName: "Template",
          field: "template_text",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        },
        {
          headerName: "Variables",
          field: "variables",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            suppressAndOrCondition: false
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      abilities: null,
      docs_template: {
        name: null,
        description: null,
        template_text: null,
        user_id: null,
        variables: [],
      },
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    CampaignAutocomplete,
    // Vue2TinymceEditor,
    VueTrumbowyg,
    
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    

  },
  mounted() {

  },
  watch: {
  },
  methods: {
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas
      self.selected_campaign = result[0]
      // console.log(self.selected_campaign)
      self.fetchClientViewAccountFields()



    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name: data[property].campaign_name + '  -   ' + data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }


              const key = 'id';

const newMappedArray = [...new Map(mappedArray.map(item => [item[key], item])).values()];              
  



  return newMappedArray;

            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewAccountFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewAccountFields",
          selected_campaign_id
        )
        .then(response => {
          this.account_columns = response.data;

         

          self.fetchClientViewOpportunityFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
        fetchClientViewOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewOpportunityFields",
          selected_campaign_id
        )
        .then(response => {
          this.opp_columns = response.data;

         

          self.fetchClientViewContactFields()


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    fetchClientViewContactFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchClientViewContactFields",
          selected_campaign_id
        )
        .then(response => {
          this.contact_columns = response.data;
          this.acc_con_columns = [...this.account_columns, ...this.contact_columns , ...this.opp_columns];


          this.acc_con_columns = this.acc_con_columns.filter(e => e.identifier != 'ddi_phone_code' && e.identifier != 'mobile_phone_code' && e.identifier != 'phone_code' && e.identifier != 'switchboard_phone_code' && e.identifier != 'phone_type')


          let sales_developer = {
            column_id: "sales_developer",
            field_type: "sales_developer",
            name: "Sales Developer",
          }

          this.acc_con_columns.push(sales_developer)

        })
        .catch(err => {
          if (err.response.status === 401) {

            console.log(err)
            this.$router.replace("/login");
          }
        });
    },
    updateVariable() {
      var self = this;
      let v_f = []
      self.savedVariables.forEach(function (e, i) {

        self.variable_fields.forEach(function (ele, index) {

          if (i == index) {
            v_f.push({ variable: e, values: ele , campaign_id :  self.selected_campaign.id})
          }
        })


      })


      this.$store.dispatch("campaignsManagement/addDocsTemplateVariable", v_f)
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Docs Template",
            text: res.data.message
          });
          this.$router.go(0);
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });

      // console.log(v_f)




    },
    setVariables(template_text) {
      var found = [],          // an array to collect the strings that are found
        rxp = /{([^}]+)}/g,
        str = template_text,
        curMatch;

      while (curMatch = rxp.exec(str)) {
        found.push(curMatch[1]);
      }
      this.docs_template.variables = found
      // console.log( this.docs_template.variables );

    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllDocsTemplate",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;

              if (response_data.length != 0) {
                self.$refs.DocsTemplate.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.DocsTemplate.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this


      self.$validator.validateAll().then(result => {
        if (result) {
          self.addDocsTemplate();
        }
      });
    },
    addDocsTemplate() {

      // console.log("sdfsdfsdfsdf" , this.docs_template.template_text)
      //  this.docs_template.template_text = this.$refs.DocsTemplateEditor.getContent()
      this.setVariables(this.docs_template.template_text)

      this.docs_template.user_id = this.user_id

      this.$store.dispatch("campaignsManagement/addDocsTemplate", this.docs_template)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Docs Template",
              text: res.data.message
            });




          } else {
            this.savedVariables = res.data

            this.createTemplate = false
            this.assignVariables = true

            document.getElementById("text_editor").classList.add("text_box");



            // this.$vs.notify({
            //   color: "success",
            //   title: "Docs Template",
            //   text: res.data.message
            // });
            // this.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    }
  }
};
</script>
<style scoped>



.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}

.ql-class {
  height: 400px;

}

.editr--content table td{
  padding: 35px;
}



</style>

<style>
body {
  font-family: "Montserrat", Helvetica, Arial, sans-serif !important;
  font-weight: 400;
}


:root {
  --tbw-cell-vertical-padding: 4px;
  --tbw-cell-horizontal-padding: 8px;
  --tbw-cell-line-height: 1.5em;
}

table {
  margin-bottom: var(--tbw-cell-line-height);
}

th,
td {
  height: calc(var(--tbw-cell-vertical-padding) * 2 + var(--tbw-cell-line-height));
  min-width: calc(var(--tbw-cell-horizontal-padding) * 2);
  padding: var(--tbw-cell-vertical-padding) var(--tbw-cell-horizontal-padding);
  border: 1px solid #e7eaec;
}


.text_box {
  display: none;
}

</style>